import { StoreAction } from '@shared/store/store-action.model';
import { StoreActionError } from '@shared/store/store-action-error.model';

import { StatisticPayload } from '../models/statistic.model';

const STATISTICS_SCOPE = '[Statistics]';
const API_SCOPE = `${ STATISTICS_SCOPE } API`;

export namespace StatisticsActions {

  export class Track extends StoreAction<StatisticPayload> {
    static override readonly type = `${ API_SCOPE } Track`;

    constructor(public override payload: StatisticPayload) {
      super(payload);
    }
  }

  export class TrackFailed extends StoreActionError {
    static override readonly type = `${ API_SCOPE } Track Failed`;
  }

  export class ResetSession extends StoreAction {
    static override readonly type = `${ STATISTICS_SCOPE } Reset Session`;
  }

  export class ResetState extends StoreAction {
    static override readonly type = `${ STATISTICS_SCOPE } Reset State`;
  }

  export class ResetLoadedState extends StoreAction {
    static override readonly type = `${ STATISTICS_SCOPE } Reset Loaded State`;
  }
}
